import React, { Component } from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { getState } from "radium"
import { Bubble } from "components"

class InteriorSwatch extends Component {
  // Radium requires stateful component to use getState()
  render() {
    const { label, imageSrc } = this.props
    return (
      <div
        data-test={"interior-swatch"}
        style={{
          position: "relative",
          cursor: "pointer",
          ":hover": { cursor: "pointer" },
          paddingLeft: "1em"
        }}>
        <img src={imageSrc} alt={`${label} interior color swatch`} style={{ width: "3em" }} />
        {label && <Bubble bottom={-3} content={label} show={getState(this.state, "main", ":hover")} />}
      </div>
    )
  }
}

InteriorSwatch.propTypes = {
  label: PropTypes.string,
  imageSrc: PropTypes.string
}

export default Radium(InteriorSwatch)



// WEBPACK FOOTER //
// ./src/components/interior-swatch/index.jsx